import styled from 'styled-components';
import { colors } from '../../variables';

const TabelRow = styled.tr`
	background-color: ${props => (props.inActive ? colors.grey.light : '#fff')};
`;

export default TabelRow;



// WEBPACK FOOTER //
// ./src/components/Common/TableRow/TableRow.js